import {
  Alert,
  Box,
  Container,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useState } from "react";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import useApiEp from "../../hooks/useApiEp";
import { useParams } from "react-router-dom";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse, getHeader } from "../../utils/util";
import { RcsTemplatePreview } from "./RcsTemplates";
import { GlassButton } from "../../themes/UiElements";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";
const AdminRcsTemplateDetail = () => {
  const { id } = useParams();
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/rcs/get-template-manage/${id}`
  );

  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [updating, setUpdating] = useState(false);

  const handleStatusUpdate = async () => {
    if (!selectedStatus) return;

    setUpdating(true);
    try {
      // Make API call to update status
      const response = await fetch(
        `${API_ENDPOINT}/rcs/update-template-status/${id}`,
        {
          method: "PUT",
          ...getHeader(),
          body: JSON.stringify({ status: selectedStatus }),
        }
      );

      if (response.ok) {
        const data = await response.json(); // 👈 parse the response body
        refetch();
        toast.success(data.message); // use the message from JSON
        setStatusDialogOpen(false);
        setSelectedStatus("");
      } else {
        throw new Error("Failed to update status");
      }
    } catch (err) {
      console.error("Error updating template status:", err);
      alert("Failed to update template status");
    } finally {
      setUpdating(false);
    }
  };

  const handleStatusDialogOpen = () => {
    setSelectedStatus(data?.status || "");
    setStatusDialogOpen(true);
  };

  const handleStatusDialogClose = () => {
    setStatusDialogOpen(false);
    setSelectedStatus("");
  };

  if (isLoading) {
    return <MuPb />;
  }

  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  return (
    <Container sx={{ mt: 3 }}>
      <BackBtn />
      <PageTitle>Template Detail</PageTitle>

      {/* Status Update Button */}
      <Box sx={{ mb: 3, display: "flex", justifyContent: "flex-end" }}>
        <GlassButton
          variant="contained"
          color="primary"
          onClick={handleStatusDialogOpen}
        >
          Update Status
        </GlassButton>
      </Box>

      {/* Template Preview */}
      {data && <RcsTemplatePreview template={data} />}

      {/* Status Update Dialog */}
      <Dialog
        open={statusDialogOpen}
        onClose={handleStatusDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Update Template Status</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset" sx={{ mt: 1 }}>
            <RadioGroup
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              {["pending", "accepted", "rejected"].map((status) => (
                <FormControlLabel
                  key={status}
                  value={status}
                  control={<Radio />}
                  label={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <span style={{ textTransform: "capitalize" }}>
                        {status}
                      </span>
                      {status === data?.status && (
                        <Box
                          sx={{
                            fontSize: "0.75rem",
                            color: "text.secondary",
                            fontStyle: "italic",
                          }}
                        >
                          (Current)
                        </Box>
                      )}
                    </Box>
                  }
                  disabled={status === data?.status || updating}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <GlassButton onClick={handleStatusDialogClose} disabled={updating}>
            Cancel
          </GlassButton>
          <GlassButton
            onClick={handleStatusUpdate}
            variant="contained"
            disabled={
              !selectedStatus || selectedStatus === data?.status || updating
            }
          >
            {updating ? "Updating..." : "Update Status"}
          </GlassButton>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AdminRcsTemplateDetail;
